import * as yup from 'yup';

export const promoCodeSchema = yup
    .object({
        promoCode: yup
            .string()
            .min(
                1,
                'Sorry, this promo code is not valid. Don’t worry though, you are still getting a great deal!'
            ),
    })
    .required();
